module.exports = __webpack_public_path__ + "img/68_17.0782ec21.png";